
// /* ------------------------------------------------------------------
//    SRSW Entry Form
//    Shared by the Free Entry (AMOE) page, the Opt In (register) page,
//    and the new Post-Purchase Registration page (checkout / order-status
//    upsell link).
//    Custom element: <srsw-entry-form>. Markup lives in snippets/srsw-entry-form.liquid.

//    data attributes on the element:
//      data-mode              "amoe" | "optin" | "postpurchase"
//      data-min-age           minimum age (number)
//      data-klaviyo-company   Klaviyo public API key (company ID)
//      data-klaviyo-metric    Klaviyo metric name for the entry event
//      data-klaviyo-list      list ID every successful entry joins
//      data-endpoint          optional custom endpoint (JSON POST)
//      data-source            source label stored with the entry
//      data-redirect          unused (kept for backwards compatibility with older templates)
//      data-done-cookie       cookie set after a successful AMOE entry (read by the landing card)
//      data-error-message     message shown when every destination fails
// ------------------------------------------------------------------- */
// (function () {
//   if (window.__srswEntryFormLoaded) return;
//   window.__srswEntryFormLoaded = true;

//   /* Same Klaviyo client API revision used by the Pappy PDP signup form */
//   var KLAVIYO_REVISION = '2026-07-15';

//   // Flat entries granted per form, recorded on the EVENT only (for
//   // reporting/reference) - never written onto the profile from here.
//   // The profile's "entries" property is owned exclusively by the Klaviyo
//   // flows, which apply the entries logic across all entry sources (free
//   // entry, registration, Pappy purchase, Shady Rays spend).
//   //
//   // "postpurchase" is the new post-purchase registration form: it exists
//   // ONLY to get the shopper onto the sweepstakes list after a purchase.
//   // It grants NO entries of its own - the Pappy Purchase and Shady Rays
//   // Spend flows are what add entries afterward, and only for shoppers who
//   // are already on the list (i.e. who have registered through this form,
//   // the free entry form, or the original opt-in form). Do not give this
//   // mode a nonzero value.
//   var ENTRIES_BY_MODE = { amoe: 50, optin: 25, postpurchase: 0 };

//   var STATES = {
//     'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA', 'Colorado': 'CO',
//     'Connecticut': 'CT', 'Delaware': 'DE', 'District of Columbia': 'DC', 'Florida': 'FL', 'Georgia': 'GA',
//     'Hawaii': 'HI', 'Idaho': 'ID', 'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS',
//     'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD', 'Massachusetts': 'MA',
//     'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS', 'Missouri': 'MO', 'Montana': 'MT',
//     'Nebraska': 'NE', 'Nevada': 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM',
//     'New York': 'NY', 'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK',
//     'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC', 'South Dakota': 'SD',
//     'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT', 'Virginia': 'VA', 'Washington': 'WA',
//     'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY'
//   };
//   var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
//   var FIELD_KEYS = ['name', 'email', 'address', 'city', 'state', 'zip', 'phone', 'dob', 'consent'];

//   function resolveState(value) {
//     var v = String(value || '').trim();
//     if (!v) return '';
//     var upper = v.toUpperCase();
//     var name;
//     for (name in STATES) {
//       if (STATES[name] === upper) return STATES[name];
//       if (name.toLowerCase() === v.toLowerCase()) return STATES[name];
//     }
//     return '';
//   }

//   function digitsOnly(value) { return String(value || '').replace(/\D/g, ''); }
//   function pad(n) { return n < 10 ? '0' + n : String(n); }

//   function isRealDate(y, m, d) {
//     var dt = new Date(y, m - 1, d);
//     return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
//   }

//   function ageToday(y, m, d) {
//     var now = new Date();
//     var age = now.getFullYear() - y;
//     var before = now.getMonth() + 1 < m || (now.getMonth() + 1 === m && now.getDate() < d);
//     return before ? age - 1 : age;
//   }

//   function setCookie(name, value, days) {
//     if (!name) return;
//     try {
//       var secure = location.protocol === 'https:' ? '; Secure' : '';
//       document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + Math.round(days * 86400) + '; path=/; SameSite=Lax' + secure;
//     } catch (e) { /* cookies blocked: the landing card just will not show the done state */ }
//   }

//   class SrswEntryForm extends HTMLElement {
//     connectedCallback() {
//       if (this._ready) return;
//       this._ready = true;
//       this.init();
//     }

//     init() {
//       this.mode = this.getAttribute('data-mode') || 'amoe';
//       this.form = this.querySelector('.srsw-form__form');
//       this.panel = this.querySelector('.srsw-form__panel');
//       this.success = this.querySelector('.srsw-form__success-overlay');
//       this.successDialog = this.querySelector('.srsw-form__success-dialog');
//       this.submitBtn = this.querySelector('.srsw-form__submit');
//       this.statusEl = this.querySelector('.srsw-form__status');
//       this.honeypot = this.querySelector('[name="company_website"]');
//       this.minAge = parseInt(this.getAttribute('data-min-age'), 10) || 21;
//       this.touched = {};
//       this.busy = false;
//       this.lastFocused = null;
//       if (!this.form) return;

//       this.buildOptions();
//       this.bindEvents();
//       this.bindSuccessOverlay();
//       this.updateSubmitState();

//       // Browsers fill saved details without firing input events until the first interaction.
//       var self = this;
//       window.setTimeout(function () { self.updateSubmitState(); }, 500);
//     }

//     buildOptions() {
//       var f = this.form.elements;
//       var i;
//       if (f.dob_month && f.dob_month.options.length < 2) {
//         for (i = 0; i < 12; i++) f.dob_month.appendChild(new Option(MONTHS[i], String(i + 1)));
//         for (i = 1; i <= 31; i++) f.dob_day.appendChild(new Option(String(i), String(i)));
//         var thisYear = new Date().getFullYear();
//         for (i = thisYear; i >= thisYear - 100; i--) f.dob_year.appendChild(new Option(String(i), String(i)));
//       }
//       var list = this.querySelector('datalist');
//       if (list && !list.children.length) {
//         Object.keys(STATES).forEach(function (name) {
//           var opt = document.createElement('option');
//           opt.value = name;
//           list.appendChild(opt);
//         });
//       }
//     }

//     bindEvents() {
//       var self = this;

//       this.form.addEventListener('input', function (event) {
//         if (event.target.name === 'zip') event.target.value = event.target.value.replace(/[^\d-]/g, '');
//         var field = event.target.closest('[data-field]');
//         if (field && self.touched[field.getAttribute('data-field')]) self.validateField(field.getAttribute('data-field'));
//         self.updateSubmitState();
//       });

//       this.form.addEventListener('change', function (event) {
//         if (event.target.tagName === 'SELECT') event.target.classList.toggle('has-value', !!event.target.value);
//         if (event.target.name === 'state') {
//           // Show the full state name when the shopper typed an abbreviation.
//           var abbr = resolveState(event.target.value);
//           if (abbr) {
//             Object.keys(STATES).forEach(function (n) { if (STATES[n] === abbr) event.target.value = n; });
//           }
//         }
//         var field = event.target.closest('[data-field]');
//         if (field) {
//           self.touched[field.getAttribute('data-field')] = true;
//           self.validateField(field.getAttribute('data-field'));
//         }
//         self.updateSubmitState();
//       });

//       // Validate a field once the shopper leaves it.
//       this.form.addEventListener('focusout', function (event) {
//         var field = event.target.closest('[data-field]');
//         if (!field) return;
//         var key = field.getAttribute('data-field');
//         if (key === 'dob' && field.contains(event.relatedTarget)) return; // still inside the date of birth
//         if (event.target.type === 'checkbox') return;
//         var f = self.form.elements;
//         if (key !== 'dob' || (f.dob_month.value && f.dob_day.value && f.dob_year.value)) {
//           self.touched[key] = true;
//           self.validateField(key);
//         }
//         self.updateSubmitState();
//       });

//       this.form.addEventListener('focusin', function () { self.updateSubmitState(); });

//       this.form.addEventListener('submit', function (event) {
//         event.preventDefault();
//         self.handleSubmit();
//       });

//       this.submitBtn.addEventListener('click', function (event) {
//         if (self.submitBtn.getAttribute('aria-disabled') === 'true') {
//           event.preventDefault();
//           // Reveal what is missing and move focus to the first problem.
//           var firstBad = self.validateAll(true);
//           if (firstBad) self.focusField(firstBad);
//         }
//       });
//     }

//     /* ---------- Success popup ---------- */

//     bindSuccessOverlay() {
//       var self = this;
//       if (!this.success) return;

//       Array.prototype.forEach.call(this.querySelectorAll('[data-srsw-success-close]'), function (el) {
//         el.addEventListener('click', function (event) {
//           event.preventDefault();
//           self.hideSuccess();
//         });
//       });

//       this.success.addEventListener('keydown', function (event) {
//         if (event.key === 'Escape' || event.key === 'Esc') {
//           event.preventDefault();
//           self.hideSuccess();
//         }
//       });
//     }

//     /* ---------- Validation ---------- */

//     fieldEl(key) { return this.form.querySelector('[data-field="' + key + '"]'); }

//     messageFor(key) {
//       var f = this.form.elements;
//       var v;
//       switch (key) {
//         case 'name':
//           v = f.name.value.trim();
//           if (!v) return 'Enter your full name.';
//           return '';
//         case 'email':
//           v = f.email.value.trim();
//           if (!v) return 'Enter your email address.';
//           if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return 'Enter a valid email address.';
//           return '';
//         case 'address':
//           v = f.address.value.trim();
//           if (!v) return 'Enter your mailing address.';
//           if (v.length < 5) return 'Enter your full mailing address.';
//           return '';
//         case 'city':
//           return f.city.value.trim() ? '' : 'Enter your city.';
//         case 'state':
//           v = f.state.value.trim();
//           if (!v) return 'Enter your state.';
//           return resolveState(v) ? '' : 'Enter a valid US state.';
//         case 'zip':
//           v = f.zip.value.trim();
//           if (!v) return 'Enter your zip code.';
//           return /^\d{5}(-\d{4})?$/.test(v) ? '' : 'Enter a valid 5 digit zip code.';
//         case 'phone':
//           v = digitsOnly(f.phone.value);
//           if (!v) return 'Enter your phone number.';
//           if (v.length === 11 && v.charAt(0) === '1') v = v.slice(1);
//           return v.length === 10 ? '' : 'Enter a valid 10 digit phone number.';
//         case 'dob':
//           if (!f.dob_month.value || !f.dob_day.value || !f.dob_year.value) return 'Select your full date of birth.';
//           var y = parseInt(f.dob_year.value, 10), m = parseInt(f.dob_month.value, 10), d = parseInt(f.dob_day.value, 10);
//           if (!isRealDate(y, m, d)) return 'Select a valid date of birth.';
//           if (ageToday(y, m, d) < this.minAge) return 'You must be ' + this.minAge + ' or older to enter.';
//           return '';
//         case 'consent':
//           return f.consent.checked ? '' : 'You must agree to the Official Rules to enter.';
//       }
//       return '';
//     }

//     validateField(key) {
//       var msg = this.messageFor(key);
//       var wrap = this.fieldEl(key);
//       if (!wrap) return msg;
//       var err = wrap.querySelector('.srsw-form__error');
//       if (err) {
//         err.textContent = msg;
//         err.hidden = !msg;
//       }
//       wrap.classList.toggle('has-error', !!msg);
//       Array.prototype.forEach.call(wrap.querySelectorAll('input:not([type="hidden"]), select'), function (el) {
//         if (msg) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
//       });
//       return msg;
//     }

//     // Returns the first invalid field key. With show = true, error messages are displayed.
//     validateAll(show) {
//       var first = '';
//       for (var i = 0; i < FIELD_KEYS.length; i++) {
//         var msg = show ? this.validateField(FIELD_KEYS[i]) : this.messageFor(FIELD_KEYS[i]);
//         if (show) this.touched[FIELD_KEYS[i]] = true;
//         if (msg && !first) first = FIELD_KEYS[i];
//       }
//       return first;
//     }

//     focusField(key) {
//       var wrap = this.fieldEl(key);
//       if (!wrap) return;
//       var el = wrap.querySelector('input:not([type="hidden"]), select');
//       if (el) el.focus();
//     }

//     updateSubmitState() {
//       if (this.busy) return;
//       var ok = !this.validateAll(false);
//       this.submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
//     }

//     /* ---------- Submit ---------- */

//     collect() {
//       var f = this.form.elements;
//       var fullName = f.name.value.trim().replace(/\s+/g, ' ');
//       var parts = fullName.split(' ');
//       var phone = digitsOnly(f.phone.value);
//       if (phone.length === 11 && phone.charAt(0) === '1') phone = phone.slice(1);
//       var y = parseInt(f.dob_year.value, 10), m = parseInt(f.dob_month.value, 10), d = parseInt(f.dob_day.value, 10);

//       return {
//         form_type: this.mode,
//         full_name: fullName,
//         first_name: parts.shift(),
//         last_name: parts.join(' '),
//         email: f.email.value.trim().toLowerCase(),
//         phone: '+1' + phone,
//         address: f.address.value.trim(),
//         city: f.city.value.trim(),
//         state: resolveState(f.state.value),
//         zip: f.zip.value.trim(),
//         country: 'US',
//         date_of_birth: y + '-' + pad(m) + '-' + pad(d),
//         marketing_opt_in: !!f.marketing.checked,
//         rules_accepted: !!f.consent.checked,
//         source: this.getAttribute('data-source') || 'Pair & Pour Sweepstakes',
//         page_url: location.href,
//         submitted_at: new Date().toISOString(),
//         entries: ENTRIES_BY_MODE[this.mode] || 0
//       };
//     }

//     klaviyoHeaders() {
//       return {
//         'Content-Type': 'application/vnd.api+json',
//         'Accept': 'application/vnd.api+json',
//         'revision': KLAVIYO_REVISION
//       };
//     }

//     sendKlaviyoEntry(company, metric, p) {
//       var uid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
//       return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
//         method: 'POST',
//         headers: this.klaviyoHeaders(),
//         body: JSON.stringify({
//           data: {
//             type: 'event',
//             attributes: {
//               // "entries" here is an EVENT property only, kept for reporting/reference
//               // (e.g. showing "50"/"25"/"0" on the entry event in Klaviyo). It is
//               // deliberately NOT included under profile.data.attributes.properties
//               // below - the profile's "entries" property is set exclusively by the
//               // Klaviyo flow(s) this event triggers. For "postpurchase" this is
//               // always 0 - this form exists only to add the shopper to the
//               // sweepstakes list; it never grants entries itself.
//               properties: {
//                 form_type: p.form_type,
//                 source: p.source,
//                 marketing_opt_in: p.marketing_opt_in,
//                 rules_accepted: p.rules_accepted,
//                 page_url: p.page_url,
//                 entries: p.entries
//               },
//               metric: { data: { type: 'metric', attributes: { name: metric || 'Sweepstakes Entry' } } },
//               profile: {
//                 data: {
//                   type: 'profile',
//                   attributes: {
//                     email: p.email,
//                     phone_number: p.phone,
//                     first_name: p.first_name,
//                     last_name: p.last_name,
//                     location: { address1: p.address, city: p.city, region: p.state, zip: p.zip, country: 'US' },
//                     properties: { sweepstakes_dob: p.date_of_birth, sweepstakes_source: p.source }
//                   }
//                 }
//               },
//               time: p.submitted_at,
//               unique_id: uid
//             }
//           }
//         })
//       }).then(function (res) {
//         if (!res.ok) throw new Error('Klaviyo event failed: ' + res.status);
//       });
//     }

//     sendKlaviyoSubscribe(company, list, p) {
//       return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
//         method: 'POST',
//         headers: this.klaviyoHeaders(),
//         body: JSON.stringify({
//           data: {
//             type: 'subscription',
//             attributes: {
//               profile: {
//                 data: {
//                   type: 'profile',
//                   attributes: {
//                     email: p.email,
//                     phone_number: p.phone,
//                     first_name: p.first_name,
//                     last_name: p.last_name
//                     // No "properties.entries" write here on purpose - see the note
//                     // in sendKlaviyoEntry above. This call's only job is the list
//                     // subscription; the flow(s) own the entries logic.
//                   }
//                 }
//               },
//               custom_source: p.source
//             },
//             relationships: { list: { data: { type: 'list', id: list } } }
//           }
//         })
//       }).then(function (res) {
//         if (!res.ok) throw new Error('Klaviyo subscribe failed: ' + res.status);
//       });
//     }

//     sendEndpoint(url, p) {
//       var controller = window.AbortController ? new AbortController() : null;
//       var timer = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
//       return fetch(url, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(p),
//         signal: controller ? controller.signal : undefined
//       }).then(function (res) {
//         if (!res.ok) throw new Error('Endpoint failed: ' + res.status);
//       }).finally(function () { if (timer) clearTimeout(timer); });
//     }

//     setBusy(state) {
//       this.busy = state;
//       if (state) {
//         this.submitBtn.setAttribute('aria-busy', 'true');
//         this.submitBtn.setAttribute('aria-disabled', 'true');
//         this.submitBtn.textContent = 'Submitting...';
//       } else {
//         this.submitBtn.removeAttribute('aria-busy');
//         this.submitBtn.textContent = this.submitBtn.getAttribute('data-label');
//         this.updateSubmitState();
//       }
//     }

//     handleSubmit() {
//       var self = this;
//       if (this.busy) return;

//       var firstBad = this.validateAll(true);
//       if (firstBad) {
//         this.updateSubmitState();
//         this.focusField(firstBad);
//         return;
//       }

//       // Bots fill hidden fields. Pretend success and send nothing.
//       if (this.honeypot && this.honeypot.value) {
//         this.finish(false);
//         return;
//       }

//       this.statusEl.textContent = '';
//       this.setBusy(true);

//       var p = this.collect();
//       var company = this.getAttribute('data-klaviyo-company');
//       var list = this.getAttribute('data-klaviyo-list');
//       var metric = this.getAttribute('data-klaviyo-metric');
//       var endpoint = this.getAttribute('data-endpoint');

//       var jobs = [];
//       if (company) jobs.push(this.sendKlaviyoEntry(company, metric, p));
//       if (endpoint) jobs.push(this.sendEndpoint(endpoint, p));

//       if (!jobs.length) {
//         // Nothing configured: fail loudly in the console so it is caught in QA.
//         console.error('[srsw] No destination configured. Set a Klaviyo company ID or an endpoint URL in the section settings.');
//         this.setBusy(false);
//         this.statusEl.textContent = this.getAttribute('data-error-message');
//         return;
//       }

//       Promise.allSettled(jobs).then(function (results) {
//         var anyOk = results.some(function (r) { return r.status === 'fulfilled'; });
//         results.forEach(function (r) { if (r.status === 'rejected') console.error('[srsw]', r.reason); });

//         if (!anyOk) {
//           self.setBusy(false);
//           self.statusEl.textContent = self.getAttribute('data-error-message');
//           return;
//         }

//         // Every successful submission joins the sweepstakes list, regardless of
//         // the marketing opt-in checkbox (that checkbox controls whether Shady
//         // Rays / Pappy & Co. send this shopper marketing emails, not whether
//         // they're tracked as a sweepstakes entrant). It never blocks or fails
//         // the entry. This call only manages the list subscription - it does NOT
//         // write the "entries" property. Entries are set entirely by the Klaviyo
//         // flow(s) triggered by the event above. For "postpurchase" mode, being
//         // added to this list is the whole point of the form: it's what makes
//         // this shopper eligible for the Pappy Purchase / Shady Rays Spend flows
//         // to actually grant entries against their order.
//         if (company && list) {
//           self.sendKlaviyoSubscribe(company, list, p).catch(function (err) { console.error('[srsw]', err); });
//         }
//         if (window.dataLayer) window.dataLayer.push({ event: 'srsw_entry_submitted', srsw_form_type: self.mode, srsw_marketing_opt_in: p.marketing_opt_in });

//         self.finish(true);
//       });
//     }

//     // Remember the entry, then show the success popup on top of the (still visible) form.
//     finish(remember) {
//       if (remember && this.mode === 'amoe') setCookie(this.getAttribute('data-done-cookie'), '1', 365);

//       this.busy = false;
//       this.submitBtn.removeAttribute('aria-busy');
//       this.submitBtn.textContent = this.submitBtn.getAttribute('data-label');
//       this.showSuccess();
//     }

//     showSuccess() {
//       this.form.reset();
//       this.touched = {};
//       Array.prototype.forEach.call(this.form.querySelectorAll('.has-error'), function (el) { el.classList.remove('has-error'); });
//       Array.prototype.forEach.call(this.form.querySelectorAll('.srsw-form__select'), function (el) { el.classList.remove('has-value'); });
//       Array.prototype.forEach.call(this.form.querySelectorAll('.srsw-form__error'), function (el) { el.hidden = true; });
//       this.updateSubmitState();
//       if (!this.success) return;

//       this.lastFocused = document.activeElement;
//       this.success.hidden = false;
//       document.documentElement.classList.add('srsw-success-lock');
//       var dialog = this.successDialog || this.success;
//       window.setTimeout(function () { dialog.focus({ preventScroll: true }); }, 10);
//     }

//     hideSuccess() {
//       if (!this.success || this.success.hidden) return;
//       this.success.hidden = true;
//       document.documentElement.classList.remove('srsw-success-lock');
//       var toFocus = this.lastFocused && document.contains(this.lastFocused) ? this.lastFocused : this.submitBtn;
//       if (toFocus && toFocus.focus) toFocus.focus({ preventScroll: true });
//       this.lastFocused = null;
//     }
//   }

//   if (!customElements.get('srsw-entry-form')) customElements.define('srsw-entry-form', SrswEntryForm);
// })();




/* ------------------------------------------------------------------
   SRSW Entry Form
   Shared by the Free Entry (AMOE) page, the Opt In (register) page,
   and the new Post-Purchase Registration page (checkout / order-status
   upsell link).
   Custom element: <srsw-entry-form>. Markup lives in snippets/srsw-entry-form.liquid.

   data attributes on the element:
     data-mode              "amoe" | "optin" | "postpurchase"
     data-min-age           minimum age (number)
     data-klaviyo-company   Klaviyo public API key (company ID)
     data-klaviyo-metric    Klaviyo metric name for the entry event
     data-klaviyo-list      list ID every successful entry joins
     data-endpoint          optional custom endpoint (JSON POST)
     data-source            source label stored with the entry
     data-redirect          unused (kept for backwards compatibility with older templates)
     data-done-cookie       cookie set after a successful AMOE entry (read by the landing card)
     data-error-message     message shown when every destination fails
------------------------------------------------------------------- */
(function () {
  if (window.__srswEntryFormLoaded) return;
  window.__srswEntryFormLoaded = true;

  /* Same Klaviyo client API revision used by the Pappy PDP signup form */
  var KLAVIYO_REVISION = '2026-07-15';

  // Flat entries granted per form, recorded on the EVENT only (for
  // reporting/reference) - never written onto the profile from here.
  // The profile's "entries" property is owned exclusively by the Klaviyo
  // flows, which apply the entries logic across all entry sources (free
  // entry, registration, Pappy purchase, Shady Rays spend).
  //
  // "postpurchase" is the new post-purchase registration form: it exists
  // ONLY to get the shopper onto the sweepstakes list after a purchase.
  // It grants NO entries of its own - the Pappy Purchase and Shady Rays
  // Spend flows are what add entries afterward, and only for shoppers who
  // are already on the list (i.e. who have registered through this form,
  // the free entry form, or the original opt-in form). Do not give this
  // mode a nonzero value.
  var ENTRIES_BY_MODE = { amoe: 50, optin: 25, postpurchase: 0 };

  var STATES = {
    'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA', 'Colorado': 'CO',
    'Connecticut': 'CT', 'Delaware': 'DE', 'District of Columbia': 'DC', 'Florida': 'FL', 'Georgia': 'GA',
    'Hawaii': 'HI', 'Idaho': 'ID', 'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS',
    'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD', 'Massachusetts': 'MA',
    'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS', 'Missouri': 'MO', 'Montana': 'MT',
    'Nebraska': 'NE', 'Nevada': 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM',
    'New York': 'NY', 'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK',
    'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC', 'South Dakota': 'SD',
    'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT', 'Virginia': 'VA', 'Washington': 'WA',
    'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY'
  };
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var FIELD_KEYS = ['name', 'email', 'address', 'city', 'state', 'zip', 'phone', 'dob', 'consent'];

  function resolveState(value) {
    var v = String(value || '').trim();
    if (!v) return '';
    var upper = v.toUpperCase();
    var name;
    for (name in STATES) {
      if (STATES[name] === upper) return STATES[name];
      if (name.toLowerCase() === v.toLowerCase()) return STATES[name];
    }
    return '';
  }

  function digitsOnly(value) { return String(value || '').replace(/\D/g, ''); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function isRealDate(y, m, d) {
    var dt = new Date(y, m - 1, d);
    return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
  }

  function ageToday(y, m, d) {
    var now = new Date();
    var age = now.getFullYear() - y;
    var before = now.getMonth() + 1 < m || (now.getMonth() + 1 === m && now.getDate() < d);
    return before ? age - 1 : age;
  }

  function setCookie(name, value, days) {
    if (!name) return;
    try {
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + Math.round(days * 86400) + '; path=/; SameSite=Lax' + secure;
    } catch (e) { /* cookies blocked: the landing card just will not show the done state */ }
  }

  class SrswEntryForm extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.init();
    }

    init() {
      this.mode = this.getAttribute('data-mode') || 'amoe';
      this.form = this.querySelector('.srsw-form__form');
      this.panel = this.querySelector('.srsw-form__panel');
      this.success = this.querySelector('.srsw-form__success-overlay');
      this.successDialog = this.querySelector('.srsw-form__success-dialog');
      this.submitBtn = this.querySelector('.srsw-form__submit');
      this.statusEl = this.querySelector('.srsw-form__status');
      this.honeypot = this.querySelector('[name="company_website"]');
      this.minAge = parseInt(this.getAttribute('data-min-age'), 10) || 21;
      this.touched = {};
      this.busy = false;
      this.lastFocused = null;
      if (!this.form) return;

      this.buildOptions();
      this.bindEvents();
      this.bindSuccessOverlay();
      this.updateSubmitState();

      if (this.mode === 'postpurchase') this.readOrderInfoFromUrl();

      // Browsers fill saved details without firing input events until the first interaction.
      var self = this;
      window.setTimeout(function () { self.updateSubmitState(); }, 500);
    }

    // The "Get Your Entries" link on the order status / thank-you page
    // carries the order's email, total, and whether it included the Pappy
    // product as query params (built from the order object in Liquid -
    // no API calls needed). Reading them here lets the post-purchase
    // registration event carry real order data, so the Pappy Purchase and
    // Shady Rays Spend Klaviyo flows can react to it directly instead of
    // having to look the order up themselves.
    //   ?email=...&order_total=123.45&has_pappy=1&order_id=1001
    readOrderInfoFromUrl() {
      var params = new URLSearchParams(location.search);
      var email = params.get('email');
      var total = parseFloat(params.get('order_total'));
      var hasPappy = params.get('has_pappy') === '1' || params.get('has_pappy') === 'true';
      var orderId = params.get('order_id') || '';

      this.orderInfo = {
        order_total: isNaN(total) ? 0 : total,
        has_pappy: !!hasPappy,
        order_id: orderId
      };

      // Prefill (not lock) the email field so returning customers don't
      // have to retype it. They can still edit it before submitting.
      var f = this.form.elements;
      if (email && f.email && !f.email.value) {
        f.email.value = decodeURIComponent(email);
        var field = this.fieldEl('email');
        if (field) { this.touched.email = true; this.validateField('email'); }
      }
    }

    buildOptions() {
      var f = this.form.elements;
      var i;
      if (f.dob_month && f.dob_month.options.length < 2) {
        for (i = 0; i < 12; i++) f.dob_month.appendChild(new Option(MONTHS[i], String(i + 1)));
        for (i = 1; i <= 31; i++) f.dob_day.appendChild(new Option(String(i), String(i)));
        var thisYear = new Date().getFullYear();
        for (i = thisYear; i >= thisYear - 100; i--) f.dob_year.appendChild(new Option(String(i), String(i)));
      }
      var list = this.querySelector('datalist');
      if (list && !list.children.length) {
        Object.keys(STATES).forEach(function (name) {
          var opt = document.createElement('option');
          opt.value = name;
          list.appendChild(opt);
        });
      }
    }

    bindEvents() {
      var self = this;

      this.form.addEventListener('input', function (event) {
        if (event.target.name === 'zip') event.target.value = event.target.value.replace(/[^\d-]/g, '');
        var field = event.target.closest('[data-field]');
        if (field && self.touched[field.getAttribute('data-field')]) self.validateField(field.getAttribute('data-field'));
        self.updateSubmitState();
      });

      this.form.addEventListener('change', function (event) {
        if (event.target.tagName === 'SELECT') event.target.classList.toggle('has-value', !!event.target.value);
        if (event.target.name === 'state') {
          // Show the full state name when the shopper typed an abbreviation.
          var abbr = resolveState(event.target.value);
          if (abbr) {
            Object.keys(STATES).forEach(function (n) { if (STATES[n] === abbr) event.target.value = n; });
          }
        }
        var field = event.target.closest('[data-field]');
        if (field) {
          self.touched[field.getAttribute('data-field')] = true;
          self.validateField(field.getAttribute('data-field'));
        }
        self.updateSubmitState();
      });

      // Validate a field once the shopper leaves it.
      this.form.addEventListener('focusout', function (event) {
        var field = event.target.closest('[data-field]');
        if (!field) return;
        var key = field.getAttribute('data-field');
        if (key === 'dob' && field.contains(event.relatedTarget)) return; // still inside the date of birth
        if (event.target.type === 'checkbox') return;
        var f = self.form.elements;
        if (key !== 'dob' || (f.dob_month.value && f.dob_day.value && f.dob_year.value)) {
          self.touched[key] = true;
          self.validateField(key);
        }
        self.updateSubmitState();
      });

      this.form.addEventListener('focusin', function () { self.updateSubmitState(); });

      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.handleSubmit();
      });

      this.submitBtn.addEventListener('click', function (event) {
        if (self.submitBtn.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          // Reveal what is missing and move focus to the first problem.
          var firstBad = self.validateAll(true);
          if (firstBad) self.focusField(firstBad);
        }
      });
    }

    /* ---------- Success popup ---------- */

    bindSuccessOverlay() {
      var self = this;
      if (!this.success) return;

      Array.prototype.forEach.call(this.querySelectorAll('[data-srsw-success-close]'), function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault();
          self.hideSuccess();
        });
      });

      this.success.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          self.hideSuccess();
        }
      });
    }

    /* ---------- Validation ---------- */

    fieldEl(key) { return this.form.querySelector('[data-field="' + key + '"]'); }

    messageFor(key) {
      var f = this.form.elements;
      var v;
      switch (key) {
        case 'name':
          v = f.name.value.trim();
          if (!v) return 'Enter your full name.';
          return '';
        case 'email':
          v = f.email.value.trim();
          if (!v) return 'Enter your email address.';
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return 'Enter a valid email address.';
          return '';
        case 'address':
          v = f.address.value.trim();
          if (!v) return 'Enter your mailing address.';
          if (v.length < 5) return 'Enter your full mailing address.';
          return '';
        case 'city':
          return f.city.value.trim() ? '' : 'Enter your city.';
        case 'state':
          v = f.state.value.trim();
          if (!v) return 'Enter your state.';
          return resolveState(v) ? '' : 'Enter a valid US state.';
        case 'zip':
          v = f.zip.value.trim();
          if (!v) return 'Enter your zip code.';
          return /^\d{5}(-\d{4})?$/.test(v) ? '' : 'Enter a valid 5 digit zip code.';
        case 'phone':
          v = digitsOnly(f.phone.value);
          if (!v) return 'Enter your phone number.';
          if (v.length === 11 && v.charAt(0) === '1') v = v.slice(1);
          return v.length === 10 ? '' : 'Enter a valid 10 digit phone number.';
        case 'dob':
          if (!f.dob_month.value || !f.dob_day.value || !f.dob_year.value) return 'Select your full date of birth.';
          var y = parseInt(f.dob_year.value, 10), m = parseInt(f.dob_month.value, 10), d = parseInt(f.dob_day.value, 10);
          if (!isRealDate(y, m, d)) return 'Select a valid date of birth.';
          if (ageToday(y, m, d) < this.minAge) return 'You must be ' + this.minAge + ' or older to enter.';
          return '';
        case 'consent':
          return f.consent.checked ? '' : 'You must agree to the Official Rules to enter.';
      }
      return '';
    }

    validateField(key) {
      var msg = this.messageFor(key);
      var wrap = this.fieldEl(key);
      if (!wrap) return msg;
      var err = wrap.querySelector('.srsw-form__error');
      if (err) {
        err.textContent = msg;
        err.hidden = !msg;
      }
      wrap.classList.toggle('has-error', !!msg);
      Array.prototype.forEach.call(wrap.querySelectorAll('input:not([type="hidden"]), select'), function (el) {
        if (msg) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
      });
      return msg;
    }

    // Returns the first invalid field key. With show = true, error messages are displayed.
    validateAll(show) {
      var first = '';
      for (var i = 0; i < FIELD_KEYS.length; i++) {
        var msg = show ? this.validateField(FIELD_KEYS[i]) : this.messageFor(FIELD_KEYS[i]);
        if (show) this.touched[FIELD_KEYS[i]] = true;
        if (msg && !first) first = FIELD_KEYS[i];
      }
      return first;
    }

    focusField(key) {
      var wrap = this.fieldEl(key);
      if (!wrap) return;
      var el = wrap.querySelector('input:not([type="hidden"]), select');
      if (el) el.focus();
    }

    updateSubmitState() {
      if (this.busy) return;
      var ok = !this.validateAll(false);
      this.submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    }

    /* ---------- Submit ---------- */

    collect() {
      var f = this.form.elements;
      var fullName = f.name.value.trim().replace(/\s+/g, ' ');
      var parts = fullName.split(' ');
      var phone = digitsOnly(f.phone.value);
      if (phone.length === 11 && phone.charAt(0) === '1') phone = phone.slice(1);
      var y = parseInt(f.dob_year.value, 10), m = parseInt(f.dob_month.value, 10), d = parseInt(f.dob_day.value, 10);

      var p = {
        form_type: this.mode,
        full_name: fullName,
        first_name: parts.shift(),
        last_name: parts.join(' '),
        email: f.email.value.trim().toLowerCase(),
        phone: '+1' + phone,
        address: f.address.value.trim(),
        city: f.city.value.trim(),
        state: resolveState(f.state.value),
        zip: f.zip.value.trim(),
        country: 'US',
        date_of_birth: y + '-' + pad(m) + '-' + pad(d),
        marketing_opt_in: !!f.marketing.checked,
        rules_accepted: !!f.consent.checked,
        source: this.getAttribute('data-source') || 'Pair & Pour Sweepstakes',
        page_url: location.href,
        submitted_at: new Date().toISOString(),
        entries: ENTRIES_BY_MODE[this.mode] || 0
      };

      // Post-purchase mode: carry the order's total and whether it
      // included the Pappy product as EVENT properties. The Pappy Purchase
      // and Shady Rays Spend Klaviyo flows trigger directly off this event
      // and read these two fields to decide how many entries to grant -
      // there is no separate "Placed Order" lookup involved, so there is
      // no ordering/race issue between "did they register yet" and "did
      // they buy yet": this one event is both at once.
      if (this.mode === 'postpurchase' && this.orderInfo) {
        p.order_total = this.orderInfo.order_total;
        p.has_pappy = this.orderInfo.has_pappy;
        p.order_id = this.orderInfo.order_id;
      }

      return p;
    }

    klaviyoHeaders() {
      return {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': KLAVIYO_REVISION
      };
    }

    sendKlaviyoEntry(company, metric, p) {
      var uid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
      return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: this.klaviyoHeaders(),
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              // Top-level "value" is Klaviyo's standard monetary field for an
              // event (distinct from the custom "properties" below). Setting it
              // to the order total for "postpurchase" events lets the Shady Rays
              // Spend flow use a native Klaviyo profile-metric SUM (all-time,
              // across every post-purchase event this profile has ever fired)
              // to compute true cumulative order value across multiple separate
              // orders - not just the single order that fired this event. For
              // every other mode it is left at 0/omitted since those modes do
              // not grant spend-based entries.
              value: (p.form_type === 'postpurchase') ? (p.order_total || 0) : undefined,
              // "entries" here is an EVENT property only, kept for reporting/reference
              // (e.g. showing "50"/"25"/"0" on the entry event in Klaviyo). It is
              // deliberately NOT included under profile.data.attributes.properties
              // below - the profile's "entries" property is set exclusively by the
              // Klaviyo flow(s) this event triggers. For "postpurchase" this is
              // always 0 - this form exists only to add the shopper to the
              // sweepstakes list; it never grants entries itself.
              properties: Object.assign({
                form_type: p.form_type,
                source: p.source,
                marketing_opt_in: p.marketing_opt_in,
                rules_accepted: p.rules_accepted,
                page_url: p.page_url,
                entries: p.entries
              }, (p.form_type === 'postpurchase') ? {
                // Read by the Pappy Purchase / Shady Rays Spend flows,
                // which trigger directly off this event.
                order_total: p.order_total || 0,
                has_pappy: !!p.has_pappy,
                order_id: p.order_id || ''
              } : {}),
              metric: { data: { type: 'metric', attributes: { name: metric || 'Sweepstakes Entry' } } },
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: p.email,
                    phone_number: p.phone,
                    first_name: p.first_name,
                    last_name: p.last_name,
                    location: { address1: p.address, city: p.city, region: p.state, zip: p.zip, country: 'US' },
                    properties: { sweepstakes_dob: p.date_of_birth, sweepstakes_source: p.source }
                  }
                }
              },
              time: p.submitted_at,
              unique_id: uid
            }
          }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo event failed: ' + res.status);
      });
    }

    sendKlaviyoSubscribe(company, list, p) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: this.klaviyoHeaders(),
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: p.email,
                    phone_number: p.phone,
                    first_name: p.first_name,
                    last_name: p.last_name
                    // No "properties.entries" write here on purpose - see the note
                    // in sendKlaviyoEntry above. This call's only job is the list
                    // subscription; the flow(s) own the entries logic.
                  }
                }
              },
              custom_source: p.source
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo subscribe failed: ' + res.status);
      });
    }

    sendEndpoint(url, p) {
      var controller = window.AbortController ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(p),
        signal: controller ? controller.signal : undefined
      }).then(function (res) {
        if (!res.ok) throw new Error('Endpoint failed: ' + res.status);
      }).finally(function () { if (timer) clearTimeout(timer); });
    }

    setBusy(state) {
      this.busy = state;
      if (state) {
        this.submitBtn.setAttribute('aria-busy', 'true');
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.textContent = 'Submitting...';
      } else {
        this.submitBtn.removeAttribute('aria-busy');
        this.submitBtn.textContent = this.submitBtn.getAttribute('data-label');
        this.updateSubmitState();
      }
    }

    handleSubmit() {
      var self = this;
      if (this.busy) return;

      var firstBad = this.validateAll(true);
      if (firstBad) {
        this.updateSubmitState();
        this.focusField(firstBad);
        return;
      }

      // Bots fill hidden fields. Pretend success and send nothing.
      if (this.honeypot && this.honeypot.value) {
        this.finish(false);
        return;
      }

      this.statusEl.textContent = '';
      this.setBusy(true);

      var p = this.collect();
      var company = this.getAttribute('data-klaviyo-company');
      var list = this.getAttribute('data-klaviyo-list');
      var metric = this.getAttribute('data-klaviyo-metric');
      var endpoint = this.getAttribute('data-endpoint');

      var jobs = [];
      if (company) jobs.push(this.sendKlaviyoEntry(company, metric, p));
      if (endpoint) jobs.push(this.sendEndpoint(endpoint, p));

      if (!jobs.length) {
        // Nothing configured: fail loudly in the console so it is caught in QA.
        console.error('[srsw] No destination configured. Set a Klaviyo company ID or an endpoint URL in the section settings.');
        this.setBusy(false);
        this.statusEl.textContent = this.getAttribute('data-error-message');
        return;
      }

      Promise.allSettled(jobs).then(function (results) {
        var anyOk = results.some(function (r) { return r.status === 'fulfilled'; });
        results.forEach(function (r) { if (r.status === 'rejected') console.error('[srsw]', r.reason); });

        if (!anyOk) {
          self.setBusy(false);
          self.statusEl.textContent = self.getAttribute('data-error-message');
          return;
        }

        // Every successful submission joins the sweepstakes list, regardless of
        // the marketing opt-in checkbox (that checkbox controls whether Shady
        // Rays / Pappy & Co. send this shopper marketing emails, not whether
        // they're tracked as a sweepstakes entrant). It never blocks or fails
        // the entry. This call only manages the list subscription - it does NOT
        // write the "entries" property. Entries are set entirely by the Klaviyo
        // flow(s) triggered by the event above. For "postpurchase" mode, being
        // added to this list is the whole point of the form: it's what makes
        // this shopper eligible for the Pappy Purchase / Shady Rays Spend flows
        // to actually grant entries against their order.
        if (company && list) {
          self.sendKlaviyoSubscribe(company, list, p).catch(function (err) { console.error('[srsw]', err); });
        }
        if (window.dataLayer) window.dataLayer.push({ event: 'srsw_entry_submitted', srsw_form_type: self.mode, srsw_marketing_opt_in: p.marketing_opt_in });

        self.finish(true);
      });
    }

    // Remember the entry, then show the success popup on top of the (still visible) form.
    finish(remember) {
      if (remember && this.mode === 'amoe') setCookie(this.getAttribute('data-done-cookie'), '1', 365);

      this.busy = false;
      this.submitBtn.removeAttribute('aria-busy');
      this.submitBtn.textContent = this.submitBtn.getAttribute('data-label');
      this.showSuccess();
    }

    showSuccess() {
      this.form.reset();
      this.touched = {};
      Array.prototype.forEach.call(this.form.querySelectorAll('.has-error'), function (el) { el.classList.remove('has-error'); });
      Array.prototype.forEach.call(this.form.querySelectorAll('.srsw-form__select'), function (el) { el.classList.remove('has-value'); });
      Array.prototype.forEach.call(this.form.querySelectorAll('.srsw-form__error'), function (el) { el.hidden = true; });
      this.updateSubmitState();
      if (!this.success) return;

      this.lastFocused = document.activeElement;
      this.success.hidden = false;
      document.documentElement.classList.add('srsw-success-lock');
      var dialog = this.successDialog || this.success;
      window.setTimeout(function () { dialog.focus({ preventScroll: true }); }, 10);
    }

    hideSuccess() {
      if (!this.success || this.success.hidden) return;
      this.success.hidden = true;
      document.documentElement.classList.remove('srsw-success-lock');
      var toFocus = this.lastFocused && document.contains(this.lastFocused) ? this.lastFocused : this.submitBtn;
      if (toFocus && toFocus.focus) toFocus.focus({ preventScroll: true });
      this.lastFocused = null;
    }
  }

  if (!customElements.get('srsw-entry-form')) customElements.define('srsw-entry-form', SrswEntryForm);
})();